<template>
    <v-text-field v-model="date" max="9999-12-31" :label="label" @input="onInput" type="date" :required="required" :rules="rules" />
</template>

<script>
    import { DateTime } from 'luxon'
    import dateUtility from '../services/dateUtility'

    // Consider the following represents a full date with timezone:
    // 2019-09-28T18:00:00+08:00

    export default {
        props: [
            'label',
            'value',
            'required',
            'rules',
            'hasDefaultDate'
        ],

        data() {
            return {
                date: null,
                offset: null,
                valid: true
            };
        },

        methods: {
            onInput() {
                var hasDate = typeof (this.date) !== "undefined" && this.date !== null && this.date !== "";

                if (hasDate) {
                    if (this.date[4] != "-") {
                        this.date = this.date.substring(0, 4) + this.date.substring(this.date.indexOf("-"));
                    }
                    var output = this.date + 'T00:00:00' + dateUtility.toIsoOffset(this.offset);
                    this.$emit('input', output);
                }

                this.valid = !this.required || hasDate;
            }
        },

        watch: {
            value: {
                immediate: true,
                handler(value) {
                    if (typeof value === 'undefined' || value === null) {
                        this.date = this.hasDefaultDate ? null : DateTime.local().toISODate();
                        this.offset = DateTime.local().offset;
                    }
                    else {
                        var dateTime = DateTime.fromISO(value, { setZone: true });
                        this.date = dateTime.toISODate();
                        this.offset = dateTime.offset;
                    }
                    if (typeof this.offset === 'undefined' || this.offset === null) {
                        this.offset = DateTime.local().offset;
                    }
                }
            }
        }
    };
</script>
